import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconModule } from "../icon/icon.module";
import { InfoItemComponent } from "./info-item/info-item.component";
import { ListComponent } from "./list.component";
import { SummaryComponent } from "./summary/summary.component";

@NgModule({
  declarations: [
    ListComponent,
    SummaryComponent,
    InfoItemComponent,
  ],
  imports: [
    CommonModule,
    IconModule,
    RouterModule,
  ],
  exports: [
    ListComponent,
    SummaryComponent,
    InfoItemComponent,
  ],
})
export class ListModule { }
